import Icon from 'common/components/elements/icons';
import Input from 'common/components/elements/inputs/inputs';
import React, { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { createPortal } from 'react-dom';
import Button from 'common/components/elements/buttons/primary';
import cx from 'classnames'
import PropTypes from 'prop-types';

// Icons/Infinity, Icon/Lightning, Icon/Puzzle, Icons/Flag, Icons/Animal, Icons/Fruit, Icon/Balance
const ICONS = [
   'photo-camera', 'cast-members-new', 'notifications', 'photosets', 'heart-filled', 'heart-outline', 'home', 'emoji',
   'password', 'lock', 'home', 'image', 'videos', 'add', 'home', 'star',
   'vault-v2', 'add', 'video-camera', 'launch', 'home', 'present', 'home', 'add',
   'home', 'add', 'stories', 'add', 'livestream', 'home', 'about', 'online-stream',
]
// onSetError
const CreatePage = ({
   errorMessage,
   selectedPage,
   onChange,
   id,
}) => {
   const [showError, setShowError] = useState(Boolean(errorMessage));
   const [openIconsDropDown, setOpenIconsDropDown] = useState(false);
   return (
      <div className='flex flex-col gap-2 flex-1'>
         <span className='text-major text-base leading-[20px] font-medium'>Page title</span>
         <div className='flex flex-col gap-[6px]'>
            <div
               data-tooltip-id='new-page-icon-dropdown'
               className={ cx(
                  {
                     'flex rounded-lg bg-panel h-10': true,
                     'border border-divider': !(showError && errorMessage),
                  }
               ) }
            >
               <div
                  onClick={ () => setOpenIconsDropDown(!openIconsDropDown) }
                  role='presentation'
                  className={ cx(
                     {
                        'flex items-center bg-grey-main px-3 py-2 gap-3 cursor-pointer': true,
                        'border border-divider rounded-l': showError && errorMessage,
                     }
                  ) }
               >
                  <div className='flex w-6 h-6 items-center justify-center'>
                     <Icon
                        name={ selectedPage?.icon || 'home' }
                        color='secondary'
                        size='2xl'
                     />
                  </div>
                  <div className='flex w-5 h-5 items-center justify-center'>
                     <Icon
                        name={ openIconsDropDown ? 'arrow-up' : 'arrow-down' }
                        color='secondary'
                        size='xl'
                     />
                  </div>
               </div>
               <Input
                  name={ `page_name_${ id }` }
                  borderStyle='none'
                  value={ selectedPage?.name || '' }
                  height='full'
                  descriptionPosition='right'
                  hideDescriptionWhenError
                  errorMessage={ errorMessage }
                  hideDescription
                  onSetError={ bool => setShowError(bool) }
                  className={ cx(
                     {
                        'border border-error rounded-r': showError && errorMessage,
                     }
                  ) }
                  onChange={ (name, value) => onChange('name', value) }
               />
            </div>
            {
               showError && errorMessage && (
                  <span className='text-xs text-error leading-[15px] text-right'>{errorMessage}</span>
               )
            }
         </div>

         {
            createPortal(
               <Tooltip
                  openOnClick
                  // role='dialog'
                  variant='light'
                  id='new-page-icon-dropdown'
                  place='bottom'
                  clickable
                  isOpen={ openIconsDropDown }
                  offset={ 4 }
                  noArrow
                  style={ {
                     padding: 0,
                     borderRadius: '8px',
                  } }
               >
                  <div
                     className='w-[340px] flex flex-col border border-divider p-4 rounded-lg items-start gap-6'
                  >
                     <div className='flex flex-wrap gap-4'>
                        {
                           ICONS.map((icon, index) => {
                              return (
                                 <div
                                    key={ index.toString() }
                                    className='flex h-6 w-6'
                                 >
                                    <Button
                                       iconName={ icon }
                                       classNames='h-full w-full flex items-center justify-center'
                                       iconSize='xl'
                                       backgroundColor='transparent'
                                       fontIconColor='secondary'
                                       onClick={ _ => onChange('icon', icon) }
                                    />
                                 </div>
                              )
                           })
                        }
                     </div>
                     <div className='flex h-5'>
                        <Button
                           text='Missing icon? Let us know'
                           iconName='feedback'
                           backgroundColor='transparent'
                           primaryColor
                           textSize='small'
                           iconPosition='left'
                           fontIconSize='base'
                           classNames='h-full flex items-center !p-0'
                           textMarginX='0 ml-2'
                        />
                     </div>

                  </div>

               </Tooltip>,
               document.getElementById('tooltips')
            )
         }

      </div>
   )
}
CreatePage.propTypes = {
   errorMessage: PropTypes.string,
   selectedPage: PropTypes.object,
   onChange: PropTypes.func,
   id: PropTypes.any,
}
export default CreatePage;
